import {
  Carousel,
  CarouselControls,
  CarouselNavigation,
  CarouselPagination,
  CarouselSlide,
} from '@cinch-labs/design-system'
import styles from './location-card-carousel.module.css'
import { SiteWithDistance } from '@cinch-labs/sites-sdk'
import { LocationCard } from './location-card'
import { buildCarouselSlideData } from './carousel-builder'
import { TrackingEventTypes, useAnalytics } from '@cinch-nx/shared-analytics'

interface LocationCardCarouselProps {
  sites: SiteWithDistance[]
  pageSiteOrgUnit?: string
  buttonText: string
}

export const LocationCardCarousel = ({
  sites,
  pageSiteOrgUnit,
  buttonText,
}: LocationCardCarouselProps) => {
  const { trackEvent } = useAnalytics()

  const handleTrackEvent = () => {
    trackEvent({
      eventName: 'collection-locations-nearby-click',
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: 'click',
          action: 'navigate',
          category: 'button',
          label: 'collection-locations-nearby-click',
          value: pageSiteOrgUnit,
        },
      },
    })
  }

  const slides = buildCarouselSlideData(sites)

  return (
    <>
      <Carousel
        customClassNames={{ wrapper: styles.carouselWrapper }}
        name="carousel"
        swiperSettings={{ allowTouchMove: false }}
      >
        {slides.map((slide, i) => (
          <CarouselSlide
            key={`card-group-${i}`}
            className={styles.carouselSlide}
          >
            {slide.map((data, j) => (
              <LocationCard
                key={data.slug}
                card={data}
                button={{ onClick: handleTrackEvent, buttonText }}
              />
            ))}
          </CarouselSlide>
        ))}
      </Carousel>
      <CarouselControls>
        <CarouselPagination name="carousel" />
        <CarouselNavigation
          name="carousel"
          ariaLabels={{ next: 'next', previous: 'previous' }}
        />
      </CarouselControls>
    </>
  )
}
